export default __webpack_public_path__ + "static/1560-c06b2f216eb872098235632362242010.gif";